import moment from 'moment-timezone';

export const timeLabel = (startDate, endDate, timeZone) => {
  if (!startDate || !endDate) {
    return null;
  }
  const startTimeText = startDate && `${moment.tz(startDate, timeZone).format('h:mm a')}`;
  const endTimeText = endDate &&
    `${moment.tz(endDate, timeZone).format('h:mm a')}${timeZone ? ` (${timeZone})` : ''}`;
  return `${startTimeText} - ${endTimeText}`;
};

export const compareWithOnlineAddress = (cityStr) => cityStr && cityStr.trim().toUpperCase() === 'ONLINE';
